/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductListPageResVo } from './ProductListPageResVo';
import {
    ProductListPageResVoFromJSON,
    ProductListPageResVoFromJSONTyped,
    ProductListPageResVoToJSON,
    ProductListPageResVoToJSONTyped,
} from './ProductListPageResVo';

/**
 * 
 * @export
 * @interface ResponseProductListPageResVo
 */
export interface ResponseProductListPageResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseProductListPageResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseProductListPageResVo
     */
    message?: string;
    /**
     * 
     * @type {ProductListPageResVo}
     * @memberof ResponseProductListPageResVo
     */
    data?: ProductListPageResVo;
}

/**
 * Check if a given object implements the ResponseProductListPageResVo interface.
 */
export function instanceOfResponseProductListPageResVo(value: object): value is ResponseProductListPageResVo {
    return true;
}

export function ResponseProductListPageResVoFromJSON(json: any): ResponseProductListPageResVo {
    return ResponseProductListPageResVoFromJSONTyped(json, false);
}

export function ResponseProductListPageResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseProductListPageResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ProductListPageResVoFromJSON(json['data']),
    };
}

export function ResponseProductListPageResVoToJSON(json: any): ResponseProductListPageResVo {
    return ResponseProductListPageResVoToJSONTyped(json, false);
}

export function ResponseProductListPageResVoToJSONTyped(value?: ResponseProductListPageResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': ProductListPageResVoToJSON(value['data']),
    };
}

